import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {buttonStyles} from '../../buttons/button'
import {DialogButton as RmwcDialogButton} from '@rmwc/dialog'
import '@rmwc/button/styles'

export const dialogButtonStyles = ({selector = '&&&'}) => css`
  ${buttonStyles({selector})}
  ${selector} {
    background: var(--mdc-theme-primary2);
    color: #fff;
  }
`

const StyledRmwcDialogButton = styled(RmwcDialogButton)`
  ${dialogButtonStyles}
`

const DialogButton = ({children, ...otherProps}) => <StyledRmwcDialogButton {...otherProps}>{children}</StyledRmwcDialogButton>

DialogButton.propTypes = {
  children: PropTypes.any,
  action: PropTypes.string
}

DialogButton.defaultProps = {
  action: 'close'
}

export {DialogButton}
